import React, { Component } from 'react'
import { observer } from 'mobx-react'
import withStyles, { ThemeProvider } from 'react-jss'

import { getLinkByParams } from 'utils/embeddableItems.utils'

import embeddableItemStyles from '../embeddableItemStyles'

@observer
class TextLink extends Component {
  render() {
    const {
      productLink,
      classes,
      productLink: { embedPrefs },
    } = this.props
    return (
      <div className={classes.marginFix}>
        <a
          target='blank'
          className={classes.textLink}
          href={getLinkByParams(productLink, productLink.product, productLink.seller)}
        >
          {embedPrefs.text}
        </a>
      </div>
    )
  }
}

const StyledTextLink = withStyles(embeddableItemStyles)(TextLink)

const TextLinkContainer = (props) => (
  <ThemeProvider theme={props.productLink.embedPrefs}>
    <StyledTextLink {...props} />
  </ThemeProvider>
)

export default TextLinkContainer
